import React from "react"

import { RosterNav, RosterNavButton } from "./RosterNav"
import {
  useRosterCategoryState,
  useRosterCategoryDispatch,
  rosterCategoryActions,
} from "../../context/RosterCategoryContext"

export function SubcategoryButtons({
  subcategories,
  selectedSubcategories,
  dispatch,
}) {
  return subcategories.map(subcategory => (
    <li key={subcategory.name}>
      <RosterNavButton
        css={`
          font-style: italic;
        `}
        active={selectedSubcategories.includes(subcategory.name)}
        onClick={() =>
          dispatch({
            type: selectedSubcategories.includes(subcategory.name)
              ? rosterCategoryActions.UNSELECT_SUBCATEGORY
              : rosterCategoryActions.SELECT_SUBCATEGORY,
            payload: subcategory.name,
          })
        }
      >
        {subcategory.name}
      </RosterNavButton>
    </li>
  ))
}

export function AllButton({ active = false, dispatch }) {
  return (
    <li key="all">
      <RosterNavButton
        active={active}
        onClick={() =>
          dispatch({
            type: rosterCategoryActions.SELECT_CATEGORY,
            payload: "all",
          })
        }
      >
        All
      </RosterNavButton>
    </li>
  )
}

export function RosterFilterMenu({ show = false, publicCategories }) {
  const { selectedCategory, selectedSubcategories } = useRosterCategoryState()
  const dispatch = useRosterCategoryDispatch()

  // If we have a selected category (aside from "all"), then we render a list with only
  // the selected category, its associated subcategories, and an "all" button to reset
  if (selectedCategory && selectedCategory !== "all") {
    const categoryRecord = publicCategories.find(
      ({ name }) => name === selectedCategory
    )

    const { subcategories } = categoryRecord

    return (
      <RosterNav expanded={show}>
        <li key={selectedCategory}>
          <RosterNavButton
            active
            onClick={() =>
              dispatch({
                type: rosterCategoryActions.SELECT_CATEGORY,
                payload: selectedCategory,
              })
            }
          >
            {selectedCategory}
          </RosterNavButton>
        </li>

        <SubcategoryButtons
          {...{
            subcategories: subcategories || [],
            selectedSubcategories,
            dispatch,
          }}
        />

        <AllButton dispatch={dispatch} />
      </RosterNav>
    )
  }

  // By default, we'll render all the top level categories as a list of buttons,
  // as well as an "all" button
  return (
    <RosterNav expanded={show}>
      {publicCategories.map(category => (
        <li key={category.name}>
          <RosterNavButton
            onClick={() =>
              dispatch({
                type: rosterCategoryActions.SELECT_CATEGORY,
                payload: category.name,
              })
            }
          >
            {category.name}
          </RosterNavButton>
        </li>
      ))}

      <AllButton dispatch={dispatch} active />
    </RosterNav>
  )
}
